module.exports = __webpack_public_path__ + "static/img/partner4.e5ffe93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partner4.png
// module id = TvjW
// module chunks = 8